export enum BankHourRequestStatus {
  PENDING = 'pending',
  SUPERVISOR_APPROVED = 'supervisor_approved',
  RH_APPROVED = 'rh_approved',
  REPROVED = 'reproved',
  CANCELED = 'canceled',
}

export type BankHourRequest = {
  id: number;
  amount: number;
  requestUser: number;
  status: BankHourRequestStatus;
  description: string;
  approvalAt: string;
  approvalUser: string;
  dateBegin: string;
  dateEnd: string;
  supervisorNote: string;
  requestUsername: string;
  isPartial: boolean;
};
